import { render, staticRenderFns } from "./ProductSalesPrice.vue?vue&type=template&id=bb9a7e76&"
import script from "./ProductSalesPrice.vue?vue&type=script&lang=js&"
export * from "./ProductSalesPrice.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports